const meta = {
  layouts: 'Panel groups',
  intervals: 'Intervals and resolution',
  'time-ranges': 'Time ranges',
  'dashboard-variables': 'Variables',
};

export default meta;
